<template>
  <div>
    <div class="navbar">
      <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
      <div class="operating-manual" v-if='!isPDF' @click="clickManual()"></div>
      <div class="right-menu">
        <el-dropdown class="avatar-container" trigger="hover">
          <div class="avatar-wrapper">
            <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->

            <img src="@/assets/homePage/userDefault.png" alt="头像" class="user-avatar" width="32" height="32">
            <!-- <i class="el-icon-caret-bottom" /> -->
            <span>{{userInfo.isAuthenticated ?userInfo.SupplierName:userInfo.LoginName}}</span>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link to="/">
              <div class="home-main">

                <el-dropdown-item>
                  <div class="home-class"></div>
                  首页
                </el-dropdown-item>
              </div>
            </router-link>
            <div class="line-navbar"></div>
            <div class="logout-main">

              <el-dropdown-item divided @click.native="logout">
                <div class="logout-class"></div>
                退出登录
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <breadcrumb class="breadcrumb-container" v-if="$route.path != '/homePage' && $route.path != '/baseInfo' && $route.path != '/invite/cooperation'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { delCookie } from '@/ask/cookiejs'
// import { removeCookie } from '@/utils/auth'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      //对应的页面点击操作手册 显示pdf对应的页数
      pageNum: {
        '/homePage': 1,
        '/basicData/channelCorrespondence': 9,
        '/basicData/storesControl': 10,
        '/channelManagement/exp': 12,
        '/channelManagement/fba': 19,
        '/channelManagement/airChannelList': 21,
        '/orderManagement/exp': 28,
        '/orderManagement/fba': 31,
        '/orderManagement/air': 31,
        '/warehouse/exp/receipt': 32,
        '/warehouse/exp/shipment': 32,
        '/operationManagement/air': 34,
        '/warehouse/fba/receipt': 32,
        '/warehouse/fba/shipment': 32,
        '/fund/bill': 38,
        '/fund/accountLimit': 39,
        '/fund/cashout': 40,
        '/baseInfo/baseInfo': 6,
      },
      userInfo: {}

    };
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    //过滤不显示操作手册的页面
    isPDF() {
      return ["pickupDriver", 'pickupChannelList', 'orderManagement/inquiry', 'orderManagement/pickup',
      ].some(
        (item) => this.$route.fullPath.indexOf(item) !== -1
      );
    },
  },
  methods: {
    clickManual() {
      let urlPath = this.$route.fullPath;
      let url = this.$apiFileCloud + this.$apiFileCloudFirst + "/SupplierFile/Supplier_Operation_Manual.pdf#page=" + this.pageNum[urlPath];
      window.open(url, '_blank')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      delCookie("X-JWT-SUPTOKEN");
      delCookie("IM-TOKENSUP")
      delCookie("SuplierLoginName")
      sessionStorage.removeItem('MenuInfo');
      //await this.$store.dispatch('user/logout')
      this.$router.push(`/login`);
      this.$router.go(0);
    }
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfo = userInfo
  }
}
</script>
<style lang="scss">
.el-dropdown-menu {
  width: 120px;
}
.line-navbar {
  width: 120px;
  height: 1px;
  border: 1px solid rgba(221, 221, 221, 0.56);
  margin: 8px 0;
}
.el-dropdown-menu__item {
  padding: 0 8px !important;
  display: flex;
  align-items: center;
  height: 32px;
  .home-class {
    width: 16px;
    height: 16px;
    background: url("../../../static/img/userInfo/icon_home_home_nor.png");
    background-size: 16px 16px;
    margin-right: 8px;
    // &:hover{
    //   background: url('../../../static/img/userInfo/icon_home_home_hover.png');
    //   background-size: 16px 16px;
    // }
  }
  .logout-class {
    width: 16px;
    height: 16px;
    background: url("../../../static/img/userInfo/icon_home_exit_nor.png");
    background-size: 16px 16px;
    margin-right: 8px;
    // &:hover{
    //   background: url('../../../static/img/userInfo/icon_home_exit_hover.png');
    //   background-size: 16px 16px;
    // }
  }
}
.router-link-active {
  width: 104px;
  margin: 0 8px;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #0046b9;
  width: 104px;
  height: 32px;
  background: rgba(0, 70, 185, 0.04);
  border-radius: 4px;
  .home-class {
    background: url("../../../static/img/userInfo/icon_home_home_hover.png");
    background-size: 16px 16px;
  }
  .logout-class {
    background: url("../../../static/img/userInfo/icon_home_exit_hover.png");
    background-size: 16px 16px;
  }
}
.logout-main {
  width: 104px;
  border-radius: 4px;
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin: 0 8px;
  &:hover {
    background: rgba(0, 70, 185, 0.04);
    color: #0046b9;
  }
}
.popper__arrow {
  display: none !important;
}
.el-dropdown-menu__item--divided {
  border-top: 0px solid #e6ebf5 !important;
}
.el-dropdown-menu__item--divided:before {
  margin: 0 !important;
}
.el-dropdown-menu {
  //display: block !important;
  margin-top: -1px !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}
.el-popper[x-placement^="bottom"] {
  // margin-top: -3px !important;
}
</style>
<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: end;
  align-items: center;
  .operating-manual {
    width: 88px;
    height: 28px;
    margin-right: 24px;
    background: url("../../../static/img/navbar/pic_gzt_bksm_nor.png");
    background-size: 88px 28px;
    cursor: pointer;
    &:hover {
      background: url("../../../static/img/navbar/pic_gzt_bksm_hover.png");
      background-size: 88px 28px;
    }
    &:active {
      background: url("../../../static/img/navbar/pic_gzt_bksm_click.png");
      background-size: 88px 28px;
    }
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 24px;

      .avatar-wrapper {
        position: relative;

        display: flex;
        align-items: center;
        height: 52px;
        padding: 0 8px;
        cursor: pointer;
        &:hover {
          background: rgba(1, 70, 185, 0.04);
        }
        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 50px;
          margin-right: 8px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
      .user-dropdown {
      }
    }
  }
}
</style>
